import React from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import SignInOutButton from "../../molecules/SignInOutButton";

// import Logo from "../../../img/logo.png";
const styles = theme => ({
  root: {
    margin: "0 0 19px",

    padding: "19px",
    borderBottom: "1px solid #e4e4e9",
    // boxShadow: "0 2px 1px rgba(121,220,186,.2)"
  },

  container: {
    flex: "1 1 100%",
    maxWidth: "1200px",
    margin: "0 auto"
  },
  logoText: {
    
    fontSize: "30px",
    
  },
  logoTextBold: {
    color: "#213262",
    fontWeight: "700"
  },
  logoBy: {
    color: "#213262",
    fontSize: "10pt",
    marginTop: "-10px",
    marginBottom: "0px",
    textAlign: "right"
  },
  logo: {
    color: "#000",
    fontFamily: '"Poppins", sans-serif',
    fontSize: "30px",
    fontWeight: "300",
    display: "inline-block",
    fontStyle: "normal",
    borderSizing: "border-box",
    textDecorationStyle: "solid",
    textDecorationLine: "none",
    textDecorationThickness: "auto",
    textDecoration: "none",
    lineHeight: "1.5",
    whiteSpace: "nowrap"
  }
});

class Header extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Container>
        {/* <div className={classes.container}> */}
          <Grid container spacing={10} alignItems="center">
            <Grid item xs={6}>
              {/* <a href="/">
                <img src={Logo} alt="CONDA Logo" />
              </a> */}
              <a className={classes.logo} href={process.env.REACT_APP_BASEURL_PAGE}>
              CRWD
              <span className={classes.logoTextBold}>Network</span>
              <div className={classes.logoBy}>by zero21</div></a>
            </Grid>
            <Grid item xs={6} align="right">
              <SignInOutButton />
            </Grid>
          </Grid>
          </Container>
        {/* </div> */}
      </div>
    );
  }
}

export default withStyles(styles)(Header);
